export default __webpack_public_path__ + "assets/images/1dc0d84b13540ee338d0c11b1db5a6d6.svg";